import axios from 'axios'
import {getStoredAccessToken} from "./authStorage";


// const baseURL = 'http://127.0.0.1:8000'
// const baseURL = 'https://stage-blackx-api.blackx.io'
const baseURL = process.env.REACT_APP_BACKEND_URL

console.log("baseURL", baseURL)

let accessToken = getStoredAccessToken()


const axiosInstance = axios.create({
    baseURL,
});

if(accessToken){
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`
}

// axiosInstance.interceptors.request.use(async req => {
//     if(!authTokens){
//         authTokens = localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null
//         req.headers.Authorization = `Bearer ${authTokens?.access}`
//     }
//
//     const user = jwt_decode(authTokens.access)
//     const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
//
//     if(!isExpired) return req
//
//     console.log('XIOSINSTANCE--->authTokens.refresh', authTokens.refresh)
//
//     const response = await axios.post(`${baseURL}/api/token/refresh/`, {
//         refresh: authTokens.refresh
//     });
//
//     localStorage.setItem('authTokens', JSON.stringify(response.data))
//     req.headers.Authorization = `Bearer ${response.data.access}`
//     return req
// })


export default axiosInstance;
